export default "__VITE_ASSET__RSlUaPB___"